import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function WhyChooseSection() {
  const { t } = useTranslation();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = sectionRef.current?.querySelectorAll('.scroll-reveal');
    elements?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-20 md:py-28 px-4 md:px-10 bg-background-50"
    >
      <div className="max-w-3xl mx-auto">
        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-semibold text-foreground-950 mb-6 scroll-reveal">
          {t('why_title')}
        </h2>

        <h3 className="font-heading text-xl md:text-2xl font-medium text-foreground-800 mb-12 scroll-reveal">
          {t('why_subtitle')}
        </h3>

        <div className="space-y-6 text-foreground-700 text-base md:text-lg leading-relaxed">
          <p className="scroll-reveal">{t('why_p1')}</p>
          <p className="scroll-reveal">{t('why_p2')}</p>
          <p className="scroll-reveal">{t('why_p3')}</p>
        </div>

        <div className="mt-14 pt-8 border-t border-background-200 scroll-reveal">
          <p className="text-foreground-700 text-base md:text-lg">
            {t('why_contact')}{" "}
            <a href="tel:+34609662599" className="text-primary-600 hover:text-primary-700 transition-colors underline underline-offset-2">
              {t('why_phone_label')} +34 609 662 599
            </a>{" "}
            email:{" "}
            <a href="mailto:info@villasyaiza.com" className="text-primary-600 hover:text-primary-700 transition-colors underline underline-offset-2">
              info@villasyaiza.com
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}